import { withDependencies } from '@wix/thunderbolt-ioc'
import { IIsDuringNavigationInteraction, INavigationInfo } from './types'
import { INavigationManager, NavigationManagerSymbol } from 'feature-navigation-manager'
import { NavigationInfoSymbol } from '@wix/thunderbolt-symbols'

export const IsDuringNavigationInteraction = withDependencies(
	[NavigationInfoSymbol, NavigationManagerSymbol],
	(navigationInfo: INavigationInfo, navigationManager: INavigationManager): IIsDuringNavigationInteraction => {
		return {
			isDuringNavigationInteraction: () =>
				navigationInfo.isDuringInitialNavigationPhase() || navigationManager.isDuringNavigation(),
		}
	}
)
